import {
    Table, TableBody, TableCell, TableHead, TableRow,
    Paper, TablePagination, TextField, Box
} from "@mui/material";
import  { useState } from "react";
import { TECHNICAL_TABLE_SCROLL_SURFACE_SX } from "./technicalTableStyles";


export default function MPTensileStrengthVsTemTable({ rows, onSearchChange, searchValue: searchValueProp }) {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState(searchValueProp ?? "");

    const temperatureColumns = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600];

    const handleChangePage = (_, newPage) => setPage(newPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        if (onSearchChange) onSearchChange(value);
    };

    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const SEARCH_FIELD_SX = {
        width: 250,
        "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            transition: "all 0.2s ease-in-out",

            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--text-primary)",
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--color-primary)",
                borderWidth: "2px",
            },
        },

        "& .MuiInputBase-input": {
            color: "var(--text-primary)",
        },

        "& .MuiInputLabel-root.Mui-focused": {
            color: "var(--text-primary)",
        },
    };


    return (
        <Paper sx={TECHNICAL_TABLE_SCROLL_SURFACE_SX}>

            <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end" }}>
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Procurar..."
                    value={searchValue}
                    onChange={handleSearchChange}
                    sx={SEARCH_FIELD_SX}
                />
            </Box>


            <Table sx={{ borderCollapse: "collapse" }}>

                <TableHead>
                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell colSpan={2}>Steel grade</TableCell>
                        <TableCell colSpan={temperatureColumns.length}>
                            Minimum tensile strength Rm (MPa) at temperature
                        </TableCell>
                    </TableRow>

                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold" } }}>
                        <TableCell>Steel name</TableCell>
                        <TableCell>Steel number</TableCell>
                        {temperatureColumns.map(t => (
                            <TableCell key={t}>{t} °C</TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {paginatedRows.map((row, rowIndex) => (
                        <TableRow
                            key={row.id || rowIndex}
                            sx={{ "& td": { border: "1px solid var(--border-color)", textAlign: "center" } }}
                        >
                            <TableCell>{row.steelName}</TableCell>
                            <TableCell>{row.steelNumber}</TableCell>

                            {temperatureColumns.map(temp => {
                                const match = row.properties.find(p => p.temperature === temp);
                                return (
                                    <TableCell key={temp}>
                                        {match ? match.minValue : "–"}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableBody>

            </Table>

            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 25, 50]}
            />

        </Paper>
    );
}
